import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.background.paper,
}

export const contentGridSx: SxProps<Theme> = {
  maxWidth: {
    lg: '112rem',
    xl: '151.6rem',
  },
  margin: 'auto',
  padding: {
    xs: '2.4rem',
    md: '2.4rem 5.6rem 2.2rem',
    lg: 0,
  },
  columnGap: {
    lg: '4.8rem',
  },
}

export const discoverPerfectTechMatchWithEaseLeftSideWrapperSx: SxProps<Theme> =
  {
    height: {
      lg: '68rem',
      xl: '69.2rem',
    },
    display: 'flex',
    alignItems: 'center',
    order: {
      xs: 1,
      lg: 'initial',
    },
  }

export const discoverPerfectTechMatchWithEaseLeftSideContentSx: SxProps<Theme> =
  {
    gap: {
      xs: '1.6rem',
      md: '2.4rem',
    },
  }

export const discoverPerfectTechMatchWithEaseRightSideWrapperSx: SxProps<Theme> =
  {
    minHeight: {
      xs: '24.2rem',
      md: 'auto',
    },
    margin: {
      xs: '2.4rem 0',
      lg: 0,
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    order: {
      xs: 2,
      lg: 'initial',
    },
  }

export const discoverPerfectTechMatchWithEaseRightSideImageSx: SxProps<Theme> =
  {
    width: { xs: '100%', md: '72.2rem', lg: '53.2rem', xl: '72.5rem' },
  }

export const takeControlTechJourneyWithConfidenceLeftSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    minHeight: {
      xs: '24.2rem',
      md: 'auto',
    },
    margin: {
      xs: '2.4rem 0',
      lg: 0,
    },
    order: {
      xs: 5,
      lg: 'initial',
    },
    justifyContent: 'center',
  }

export const takeControlTechJourneyWithConfidenceLeftSideImageSx: SxProps<Theme> =
  {
    width: { xs: '100%', md: '72.2rem', lg: '53.2rem', xl: '73rem' },
  }

export const takeControlTechJourneyWithConfidenceRightSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    order: {
      xs: 4,
      lg: 'initial',
    },
  }

export const takeControlTechJourneyWithConfidenceRightSideContentSx: SxProps<Theme> =
  {
    justifyContent: 'center',
    gap: {
      xs: '1.6rem',
      md: '2.4rem',
    },
    height: {
      lg: '62.4rem',
      xl: '60.8rem',
    },
  }

export const discoverSolutionTrustedProvidersLeftSideWrapperSx: SxProps<Theme> =
  {
    height: {
      lg: '66.4rem',
      xl: '60.8rem',
    },
    display: 'flex',
    alignItems: 'center',
    order: {
      xs: 7,
      lg: 'initial',
    },
  }

export const discoverSolutionTrustedProvidersLeftSideContentSx: SxProps<Theme> =
  {
    gap: {
      xs: '1.6rem',
      md: '2.4rem',
    },
  }

export const discoverSolutionTrustedProvidersRightSideWrapperSx: SxProps<Theme> =
  {
    minHeight: {
      xs: '24.2rem',
      md: 'auto',
    },
    margin: {
      xs: '2.4rem 0 2.6rem',
      md: '3.6rem 0',
      lg: 0,
    },
    display: 'flex',
    alignItems: 'center',
    order: {
      xs: 8,
      lg: 'initial',
    },
    justifyContent: 'center',
  }

export const discoverSolutionTrustedProvidersRightSideImageSx: SxProps<Theme> =
  {
    width: { xs: '100%', md: '72.2rem', lg: '53.2rem', xl: '73.4rem' },
  }

export const dividerWrapperSx: SxProps<Theme> = {
  padding: 0,
  order: {
    xs: 3,
    lg: 'initial',
  },
}
export const secondDividerWrapperSx: SxProps<Theme> = {
  padding: 0,
  order: {
    xs: 6,
    lg: 'initial',
  },
}

export const titleSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.main,
  letterSpacing: 0,
  paddingTop: {
    xs: '2.4rem',
    lg: 0,
  },
}
